"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRemoveShippingOfferItemErrorResponse = exports.RemoveShippingOfferItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'remove-shipping-offer-item-failed';
const RemoveShippingOfferItemFailedEvent = exports.RemoveShippingOfferItemFailedEvent = Name;
const isRemoveShippingOfferItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isRemoveShippingOfferItemErrorResponse = isRemoveShippingOfferItemErrorResponse;
//# sourceMappingURL=index.js.map